import React, { FC, useEffect, useRef } from 'react'

import { FieldProps, useDataProvider, useRecordContext } from 'react-admin'

import { ReactFormBuilder } from 'formtopia/react-form-builder/editor'
import { debounce, usePrevious } from 'shared/helpers'

export const FormDesignTab: FC<FieldProps & { hidden?: boolean }> = ({ hidden, ...rest }) => {
  const dataProvider = useDataProvider()
  const formBuilder = useRef<ReactFormBuilder>()

  const prevHidden: boolean = usePrevious(hidden)

  const record = useRecordContext()

  if (!record) return null

  const debounced = debounce((args) => {
    dataProvider
      .update('Form', { id: record.id, data: { id: record.id, ...args }, previousData: record })
      .catch((error) => {
        console.log('error', error)
      })
  }, 500)

  const onFormChanged = ({ code: source }) => {
    debounced({ source })
  }

  useEffect(() => {
    // need to refresh the CodeMirror editor when tab becomes visible in order for it to render consistently
    // https://stackoverflow.com/questions/8349571/codemirror-editor-is-not-loading-content-until-clicked
    if (prevHidden && hidden == false) {
      formBuilder.current.formEditor._ed.refresh()
    }
  }, [hidden])

  return (
    <ReactFormBuilder ref={formBuilder} {...rest} initialValue={record.source} formPath={record['path']} onFormChanged={onFormChanged} />
  )
}